import styled from 'styled-components';

export const StyledPopoverContent = styled.div`
  font-size: 12px;
  padding: 10px;
`